import React from 'react'
import { TimeSeriesRow, RainType, Coordinates, Bounds } from 'common/types'
import { IDs } from 'common/consts'
import { SplitImageLayer } from 'components/layers/SplitImageLayer'
import { convertCoordinates } from 'common/utils'

export type RainSplitLayerProps = {
  rain: TimeSeriesRow | null
  opacity: number
}

const bounds: {[key in RainType]: Bounds} = {
  nowcast: [
    [46.666666, 120],
    [20.666666, 149]
  ],
  forecast: [
    [48, 118],
    [20, 150]
  ],
  msm: [
    [47.625, 119.96875],
    [22.375, 150.03125]
  ]
}

export const RainWideLayer = ({rain, opacity}: RainSplitLayerProps) => {

  const visibility = React.useMemo((): boolean => rain !== null, [rain])

  const coordinates = React.useMemo((): Coordinates => {
    return !rain || !rain.type ? [] : convertCoordinates(bounds[rain.type])
  }, [rain])

  return (
    <>
      <SplitImageLayer
        url={rain ? rain.url : null}
        coordinates={coordinates}
        sourceId={IDs.rainfall.wideSource}
        layerId={IDs.rainfall.wideLayer}
        splitNum={5}
        opacity={opacity}
        visibility={visibility}
      />
    </>
  )
}
